var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.5C1.25 4.94614 4.94614 1.25 9.5 1.25C14.0539 1.25 17.75 4.94614 17.75 9.5C17.75 14.0539 14.0539 17.75 9.5 17.75C4.94614 17.75 1.25 14.0539 1.25 9.5Z",
    fill: "white",
    stroke: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4502 4.25H10.5502V14.75H8.4502V4.25Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.5492V8.44922H14.75V10.5492H4.25Z",
    fill: "#B7B7B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusicon);
export default __webpack_public_path__ + "static/media/plusicon.2feba546.svg";
export { ForwardRef as ReactComponent };